(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-categories"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCategories extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.featured-categories__grid');
      this.prev = this.querySelector('.featured-categories__arrow--prev');
      this.next = this.querySelector('.featured-categories__arrow--next');
      if (!this.grid || (!this.prev && !this.next)) return;

      this._onPrev = () => this._scrollBy(-1);
      this._onNext = () => this._scrollBy(1);
      this._update = () => this._updateArrows();

      if (this.prev) this.prev.addEventListener('click', this._onPrev);
      if (this.next) this.next.addEventListener('click', this._onNext);
      this.grid.addEventListener('scroll', this._update, { passive: true });
      window.addEventListener('resize', this._update);
      this._updateArrows();
    }

    disconnectedCallback() {
      if (this.prev) this.prev.removeEventListener('click', this._onPrev);
      if (this.next) this.next.removeEventListener('click', this._onNext);
      if (this.grid) this.grid.removeEventListener('scroll', this._update);
      window.removeEventListener('resize', this._update);
    }

    _scrollBy(dir) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const delta = Math.round(this.grid.clientWidth * 0.8) * dir;
      this.grid.scrollBy({ left: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    _updateArrows() {
      const max = this.grid.scrollWidth - this.grid.clientWidth - 1;
      if (this.prev) this.prev.toggleAttribute('hidden', this.grid.scrollLeft <= 0);
      if (this.next) this.next.toggleAttribute('hidden', this.grid.scrollLeft >= max);
    }
  }

  if (!customElements.get('featured-categories')) {
    customElements.define('featured-categories', FeaturedCategories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hero-slideshow__track');
      this.dots = Array.from(this.querySelectorAll('.hero-slideshow__dot'));
      this.slides = Array.from(this.querySelectorAll('.hero-slide'));
      this.activeIndex = 0;
      this.isOnScreen = true;

      if (!this.track || this.slides.length === 0) return;

      this._setupObserver();
      this._setupDots();
      this._setupArrows();

      if (this.hasAttribute('autoplay')) {
        this._setupAutoplay();
      }
    }

    disconnectedCallback() {
      clearInterval(this._timer);
      if (this._observer) this._observer.disconnect();
      if (this._rootObserver) this._rootObserver.disconnect();
      if (this._visibilityHandler) {
        document.removeEventListener('visibilitychange', this._visibilityHandler);
      }
    }

    _setupObserver() {
      this._observer = new IntersectionObserver(
        (entries) => {
          let bestRatio = 0;
          let bestIdx = this.activeIndex;
          for (const entry of entries) {
            if (entry.intersectionRatio > bestRatio) {
              bestRatio = entry.intersectionRatio;
              bestIdx = this.slides.indexOf(entry.target);
            }
          }
          if (bestIdx >= 0 && bestIdx !== this.activeIndex && bestRatio >= 0.5) {
            this._setActive(bestIdx);
          }
        },
        { root: this.track, threshold: [0.25, 0.5, 0.75, 1] }
      );
      this.slides.forEach((slide) => this._observer.observe(slide));
    }

    _setActive(idx) {
      this.activeIndex = idx;
      this.dots.forEach((d, i) => {
        d.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
    }

    _setupDots() {
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this._goTo(i));
      });
    }

    _setupArrows() {
      const loop = this.dataset.loop !== 'false';
      this.querySelectorAll('.hero-slideshow__arrow').forEach((btn) => {
        btn.addEventListener('click', () => {
          const dir = btn.dataset.direction === 'prev' ? -1 : 1;
          let next = this.activeIndex + dir;
          if (next < 0) next = loop ? this.slides.length - 1 : 0;
          if (next >= this.slides.length) next = loop ? 0 : this.slides.length - 1;
          this._goTo(next);
        });
      });
    }

    _goTo(idx) {
      const target = this.slides[idx];
      if (!target) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({
        left: target.parentElement.offsetLeft,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    _setupAutoplay() {
      const speed = (parseFloat(this.getAttribute('autoplay-speed')) || 5) * 1000;
      const loop = this.dataset.loop !== 'false';

      const advance = () => {
        let next = this.activeIndex + 1;
        if (next >= this.slides.length) {
          if (!loop) {
            this._stop();
            return;
          }
          next = 0;
        }
        this._goTo(next);
      };

      const start = () => {
        clearInterval(this._timer);
        if (!this.isOnScreen || document.hidden) return;
        this._timer = setInterval(advance, speed);
      };
      const stop = () => clearInterval(this._timer);
      this._start = start;
      this._stop = stop;

      start();
      this.addEventListener('pointerenter', stop);
      this.addEventListener('pointerleave', start);
      this.addEventListener('focusin', stop);
      this.addEventListener('focusout', start);

      this._visibilityHandler = () => {
        if (document.hidden) stop();
        else start();
      };
      document.addEventListener('visibilitychange', this._visibilityHandler);

      this._rootObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            this.isOnScreen = entry.isIntersecting;
            if (this.isOnScreen) start();
            else stop();
          }
        },
        { threshold: 0.1 }
      );
      this._rootObserver.observe(this);
    }
  }

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
